export default {
  namespaced: true,
  state: {
    logDetailKey: [
      { key: "target_function_id", value: "Target Function ID" },
      { key: "target_page_id", value: "Target Page ID" },
      { key: "target_role_id", value: "Target Role ID" },
      { key: "target_user_status", value: "Target User Status" },
      { key: "function_id", value: "Function ID" },
      { key: "function_name", value: "function_name" },
      { key: "new_function_name", value: "New function_name" },
      { key: "new_page_id", value: "New Page ID" },
      { key: "new_page_name", value: "New Page Name" },
      { key: "new_role_id", value: "New Role ID" },
      { key: "new_role_name", value: "New Role Name" }
    ],
    logStatusDesc: [
      { key: "OK", value: "OK" },
      { key: "invalidParameter", value: "Invalid Parameter" },
      { key: "systemError", value: "System unable to process your request" },
      { key: "spErrorMessage", value: "SP Message Error" },
      { key: "actionbyRequired", value: "Current User is required" },
      { key: "sessionTokenRequired", value: "Session Token is required" },
      { key: "pageIdRequired", value: "Page ID is required" },
      { key: "functionIdRequired", value: "Function ID is required" },
      { key: "functionNameRequired", value: "Function Name is required" },
      { key: "targetFunctionIdRequired", value: "Target Function ID is required" },
      { key: "newFunctionNameRequired", value: "New Function Name is required" },
      { key: "newPageIdRequired", value: "Page ID is required" },
      { key: "newPageNameRequired", value: "Page name is required" },
      { key: "targetPageIdRequired", value: "Target Page ID is required" },
      { key: "newRoleIdRequired", value: "Role ID is required" },
      { key: "newRoleNameRequired", value: "Role Name is required" },
      { key: "targetRoleIdRequired", value: "Target Role ID is required" },
      { key: "userIdRequired", value: "User ID is required" },
      { key: "passwordRequired", value: "Password is required" },
      { key: "userNameRequired", value: "Full Name is required" },
      { key: "passwordValidation", value: "Password must be 6-20 characters and a combination of number(s) and letter(s)" },
      { key: "pageNumRequired", value: "Page Number is required" },
      { key: "pageSizeRequired", value: "Page Size is required" },
      { key: "roleIdRequired", value: "Role ID is required" },
      { key: "oldPasswordRequired", value: "Current Password is required" },
      { key: "userStatusRequired", value: "User Status is required" },
      { key: "thisRoleExists", value: "This Role already exists" },
      { key: "thisRoleNotExists", value: "This Role is not exists" },
      { key: "thisRoleNotAllowDelete", value: "This Role is not allow to delete, it has been used" },
      { key: "thisPageExists", value: "This Page is already exists" },
      { key: "thisPageNotExists", value: "This Page is not exists" },
      { key: "thisPageNotAllowDelete", value: "This Page is not allow to delete, it has been used" },
      { key: "thisUserExists", value: "This User is already exists" },
      { key: "thisUserNotExists", value: "This User is not exists" },
      { key: "invalidPassword", value: "Invalid Username or Password" },
      { key: "invalidLogin", value: "Invalid Username or Password" },
      { key: "thisUserBlackListed", value: "Your account has been blacklisted" },
      { key: "thisUserInactive", value: "Your account has been inactive" },
      { key: "thisUserBlocked", value: "Your account has been blocked" },
      { key: "thisUserNotActive", value: "Your account has been not active" },
      { key: "invalidUser", value: "Invalid User!" },
      { key: "invalidToken", value: "Invalid Session!" },
      { key: "NoUserAccessRight", value: "Permission Denied!" },
      { key: "InvalidPageFunction", value: "Invalid Page Function" },
      { key: "thisFunctionExists", value: "This Function already exists" },
      { key: "thisFunctionNotExists", value: "This Function not exists" },
      { key: "thisFunctionNotAllowDelete", value: "This Function is not allowed to delete, it has been used" },
      { key: "invalidPageNumber", value: "Invalid page number" },
      { key: "invalidPageSize", value: "Invalid page size" },
      { key: "unableSPProcess", value: "System unable to process your request" },
      { key: "permissionDenied", value: "Permission is denied" },
      { key: "startDateRequired", value: "Start Date is required." },
      { key: "endDateRequired", value: "End Date is required." },
      { key: "startDateIsGteEndDate", value: "Start Date is greater than End Date." },
      { key: "success", value: "Success" },
      { key: "thisTypeExists", value: "This type is existed" },
      { key: "thisTypeNotExists", value: "This type is not existed" },
      { key: "thisTypeUsed", value: "This type have been used" },
      { key: "thisCategoryExists", value: "This category is existed" },
      { key: "thisCategoryNotExists", value: "This category is not existed" },
      { key: "thisCategoryUsed", value: "This category have been used" },
      { key: "thisLanguageExists", value: "This language is existed" },
      { key: "thisLanguageNotExists", value: "This language is not existed" },
      { key: "thisLanguageUsed", value: "This language have been used" },
      { key: "thisCountryExists", value: "This country is existed" },
      { key: "thisCountryNotExists", value: "This country is not existed" },
      { key: "thisCountryUsed", value: "This country have been used" },
      { key: "thisRatingExists", value: "This rating is existed" },
      { key: "thisRatingNotExists", value: "This rating is not existed" },
      { key: "thisRatingUsed", value: "This rating have been used" },
      { key: "thisSiteExists", value: "This site is existed" },
      { key: "thisSiteNotExists", value: "This site is not existed" },
      { key: "thisSiteUsed", value: "This site have been used" },
      { key: "thisVideoExists", value: "This video is existed" },
      { key: "thisVideoNotExists", value: "This video is not existed" },
      { key: "thisVideoUsed", value: "This video have been used" },
      { key: "thisSeasonExists", value: "This season is existed" },
      { key: "thisSeasonNotExists", value: "This season is not existed" },
      { key: "thisSeasonUsed", value: "This season have been used" },
      { key: "thisEpisodeExists", value: "This episode is existed" },
      { key: "thisEpisodeNotExists", value: "This episode is not existed" },
      { key: "thisEpisodeUsed", value: "This episode have been used" },
      { key: "thisSubtitleExists", value: "This subtitle is existed" },
      { key: "thisSubtitleNotExists", value: "This subtitle is not existed" },
      { key: "thisSubtitleUsed", value: "This subtitle have been used" },
      { key: "NotAllowedUpdSeason", value: "Not Allowed to update season" },
      { key: "thisQualityExists", value: "This quality is existed" },
      { key: "thisQualityNotExists", value: "This quality is not existed" },
      { key: "thisQualityUsed", value: "This quality have been used" },
      { key: "NotAuthorization", value: "No Authorization" },
      { key: "NotAllowtoAccess", value: "No allowed to access this site" },
      { key: "thisVideoResolutionExists", value: "This video resolution url is existed" },
      { key: "thisVideoResolutionNotExists", value: "This video resolution url is not existed" },
      { key: "thisVideoResolutionUsed", value: "This video resolution url have been used" },
      { key: "categoryCodeRequired", value: "Category code is required" },
      { key: "categoryDescRequired", value: "Category description is required" },
      { key: "categoryCodeLessLength", value: "Less than the length of category code." },
      { key: "categoryCodeOverLength", value: "More than the length of category code" },
      { key: "categoryDescLessLength", value: "Less than the length of category description" },
      { key: "categoryDescOverLength", value: "More than the length of category description" },
      { key: "categoryDescCNLessLength", value: "Less than the length of category description (chinese)" },
      { key: "categoryDescCNOverLength", value: "More than the length of category description (chinese)" },
      { key: "statusRequired", value: "Status is required" },
      { key: "statusLessLength", value: "Less than the length of status" },
      { key: "statusOverLength", value: "More than the length of status" },
      { key: "countryCodeRequired", value: "Country code is required" },
      { key: "countryDescCNRequired", value: "Country Description (chinese) is required" },
      { key: "countryCodeLessLength", value: "Less than the length of country code" },
      { key: "countryCodeOverLength", value: "More than the length of country code" },
      { key: "countryDescLessLength", value: "Less than the length of country description" },
      { key: "countryDescOverLength", value: "More than the length of country description" },
      { key: "countryDescCNLessLength", value: "Less than the length of country description (chinese)" },
      { key: "countryDescCNOverLength", value: "More than the length of country description (chinese)" },
      { key: "languageCodeRequired", value: "Language code is required" },
      { key: "languageDescRequired", value: "Language desciption is required" },
      { key: "languageCodeLessLength", value: "Less than the length of language code" },
      { key: "languageCodeOverLength", value: "More than the length of language code" },
      { key: "languageDescLessLength", value: "Less than the length of language description" },
      { key: "languageDescOverLength", value: "More than the length of language description" },
      { key: "languageDescCNLessLength", value: "Less than the length of language description (chinese)" },
      { key: "languageDescCNOverLength", value: "More than the length of language description (chinese)" },
      { key: "qualityDescRequired", value: "Quality Description is required" },
      { key: "qualityDescLessLength", value: "Less than the length of quality description" },
      { key: "qualityDescOverLength", value: "More than the length of quality description" },
      { key: "qualityIdRequired", value: "Quality id is required" },
      { key: "ratingCodeRequired", value: "Rating code is required" },
      { key: "ratingDescRequired", value: "Rating description is required" },
      { key: "ratingCodeLessLength", value: "Less than the length of rating code" },
      { key: "ratingCodeOverLength", value: "More than the length of rating code" },
      { key: "ratingDescLessLength", value: "Less than the length of rating description" },
      { key: "ratingDescOverLength", value: "More than the length of rating description" },
      { key: "ratingDescCNLessLength", value: "Less than the length of rating description (chinese)" },
      { key: "ratingDescCNOverLength", value: "More than the length of rating description (chinese)" },
      { key: "typeCodeRequired", value: "Type code is required" },
      { key: "typeDescCNRequired", value: "Type description (chinese) is required" },
      { key: "typeDescRequired", value: "Type description is required" },
      { key: "typeCodeLessLength", value: "Less than the length of type code" },
      { key: "typeCodeOverLength", value: "More than the length of type code" },
      { key: "typeDescLessLength", value: "Less than the length of type description" },
      { key: "typeDescOverLength", value: "More than the length of type description" },
      { key: "typeDescCNLessLength", value: "Less than the length of type description (chinese)" },
      { key: "typeDescCNOverLength", value: "More than the length of type description (chinese)"},
      { key: "siteDescRequired", value: "Site description is required" },
      { key: "siteDomainRequired", value: "Site domain is required" },
      { key: "siteDescLessLength", value: "Less than the length of site description" },
      { key: "siteDescOverLength", value: "More than the length of site description" },
      { key: "siteDomainLessLength", value: "Less than the length of site domain" },
      { key: "siteDomainOverLength", value: "More than the length of site domain" },
      { key: "invalidSiteRate", value: "Invalid site rate" },
      { key: "siteAPIKeyFailed", value: "Site API key is failed" },
      { key: "siteIDRequired", value: "Site id is required" },
      { key: "titleRequired", value: "Title is required" },
      { key: "titleLessLength", value: "Less than the length of title" },
      { key: "titleOverLength", value: "More than the length of title" },
      { key: "titleCNLessLength", value: "Less than the length of title (chinese)" },
      { key: "titleCNOverLength", value: "More than the length of title (chinese)" },
      { key: "descLessLength", value: "Less than the length of description" },
      { key: "descOverLength", value: "More than the length of description" },
      { key: "descCNLessLength", value: "Less than the length of description (chinese)" },
      { key: "descCNOverLength", value: "More than the length of description (chinese)" },
      { key: "actorListLessLength", value: "Less than the length of artist list" },
      { key: "actorListOverLength", value: "More than the length of artist list" },
      { key: "invalidLength", value: "Invalid duration" },
      { key: "invalidYear", value: "Invalid released year" },
      { key: "directorLessLength", value: "Less than the length of director" },
      { key: "directorOverLength", value: "More than the length of director" },
      { key: "screenplayLessLength", value: "Less than the length of screenplay" },
      { key: "screenplayOverLength", value: "More than the length of screenplay" },
      { key: "producedLessLength", value: "Less than the length of produced" },
      { key: "producedOverLength", value: "More than the length of produced" },
      { key: "productCompanyLessLength", value: "Less than the length of product company" },
      { key: "productCompanyOverLength", value: "More than the length of product company" },
      { key: "invalidSeason", value: "Invalid season" },
      { key: "invalidIMDB", value: "Invalid IMDB" },
      { key: "invalidPremium", value: "Invalid premium" },
      { key: "invalidFinalEpisode", value: "Invalid final episode" },
      { key: "invalidTotallike", value: "Invalid total like" },
      { key: "invalidTotalUnlike", value: "Invalid total unlike" },
      { key: "invalidTotalView", value: "Invalid total view" },
      { key: "invalidTotalFeatured", value: "Invalid total featured" },
      { key: "thumbnailLessLength", value: "Less than the length of thumbnail" },
      { key: "thumbnailOverLength", value: "More than the length of thumbnail" },
      { key: "landscapeThumbnailLessLength", value: "Less than the length of landscape thumbnail" },
      { key: "landscapeThumbnailOverLength", value: "More than the length of landscape thumbnail" },
      { key: "videoIdRequired", value: "Video id is required" },
      { key: "levelRequired", value: "Level is required" },
      { key: "seasonRequired", value: "Season is required" },
      { key: "seasonIdRequired", value: "Season id is required" },
      { key: "episodeRequired", value: "Episode is required" },
      { key: "episodeIdRequired", value: "Episode id is required" },
      { key: "urlRequired", value: "Url is required" },
      { key: "urlLessLength", value: "Less than the length of url" },
      { key: "urlOverLength", value: "More than the length of url" },
      { key: "subtitleIdRequired", value: "Subtitle id is required" }
    ],
    logActionKey: [
      { key: "user", value: "User" },
      { key: "page", value: "Page" },
      { key: "pagerole", value: "Page Role" },
      { key: "function", value: "Function" },
      { key: "role", value: "Role" },
      { key: "type", value: "Type" },
      { key: "category", value: "Category" },
      { key: "language", value: "Language" },
      { key: "country", value: "Country" },
      { key: "rating", value: "Rating" },
      { key: "quality", value: "Quality" },
      { key: "site", value: "Site" },
      { key: "video", value: "Video" },
      { key: "season", value: "Season" },
      { key: "episode", value: "Episode" },
      { key: "subtitle", value: "Subtitle" }
    ],
    logTargetActionKey: [
      { key: "createuser", value: "Create User" },
      { key: "upsertpagerole", value: "Assign Page Role" },
      { key: "useraddroles", value: "Add User Role" },
      { key: "changepassword", value: "Change User Password" },
      { key: "resetuserpassword", value: "Reset User Password" },
      { key: "updatestatus", value: "Update Status" },
      { key: "addfunction", value: "Add Function" },
      { key: "deletefunction", value: "Delete Function" },
      { key: "editfunction", value: "Edit Function" },
      { key: "addpage", value: "Add Page" },
      { key: "deletepage", value: "Delete Page" },
      { key: "editpage", value: "Edit Page" },
      { key: "addrole", value: "Add Role" },
      { key: "deleterole", value: "Delete Role" },
      { key: "editrole", value: "Edit Role" },
      { key: "assigneventgame", value: "Assign Event Game" },
      { key: "assigneventhost", value: "Assign Event Host" },
      { key: "assigneventquestion", value: "Assign Event Question" },
      { key: "createevent", value: "Create Event" },
      { key: "updateevent", value: "Update Event" },
      { key: "updateeventstatus", value: "Update Event Status" },
      { key: "addgame", value: "Add Game" },
      { key: "deletegame", value: "Delete Game" },
      { key: "updategame", value: "Update Game" },
      { key: "addhost", value: "Add Host" },
      { key: "resethostpassword", value: "Reset Host Password" },
      { key: "updatehost", value: "Update Host" },
      { key: "updatehostpassword", value: "Update Host Password" },
      { key: "updatehoststatus", value: "Update Host Status" },
      { key: "updateplayerstatus", value: "Update Player Status" },
      { key: "addquestion", value: "Add Question" },
      { key: "addquestiongroup", value: "Add Question Group" },
      { key: "deletequestion", value: "Delete Question" },
      { key: "deletequestiongroup", value: "Delete Question Group" },
      { key: "updatequestion", value: "Update Question" },
      { key: "updatequestiongroup", value: "Update Question Group" },
      { key: "addgiftsetting", value: "Add Gift Setting" },
      { key: "deletegiftsetting", value: "Delete Gift Setting" },
      { key: "updategiftsetting", value: "Update Gift Setting" },
      { key: "updategiftstatus", value: "Update Gift Status" },
      { key: "updatetokensetting", value: "Update Token Setting" },
      { key: "answerquestion", value: "Answer Question" },
      { key: "dailyclaim", value: "Daily Claim" },
      { key: "playerlogin", value: "Player Login" },
      { key: "playersendgift", value: "Player Send Gift" }
    ]
  },
  getters: {
    getlogDetailByKey: state => {
      return sKey =>
        state.logDetailKey.reduce((result, logDetailKey) => {
          if (logDetailKey.key === sKey) {
            result = logDetailKey.value;
          }
          return result;
        }, sKey);
    },
    getlogStatusDescByKey: state => {
      return sStatusDesc =>
        state.logStatusDesc.reduce((result, logStatusDesc) => {
          if (logStatusDesc.key === sStatusDesc) {
            result = logStatusDesc.value;
          }
          return result;
        }, sStatusDesc);
    },
    getlogActionList: state => {
      return state.logActionKey;
    },
    getlogTargetActionKey: state => {
      return sKey =>
        state.logTargetActionKey.reduce((result, logTargetActionKey) => {
          if (logTargetActionKey.key === sKey) {
            result = logTargetActionKey.value;
          }
          return result;
        }, sKey);
    },
  }
};
